export enum DtwinListDisplayContext {
  DTWINS,
  FLEET,
  DTWIN_DETAIL,
}
